var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-facebook"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 33
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    clipPath: "url(#clip-facebook)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-facebook-square",
    transform: "translate(3.052 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-square-2",
    d: "M25.469,2.25H3.056A2.9,2.9,0,0,0,0,4.964v19.9a2.9,2.9,0,0,0,3.056,2.714H11.8V18.971H7.784V14.917H11.8v-3.09c0-3.514,2.356-5.456,5.964-5.456a27.276,27.276,0,0,1,3.535.274v3.449H19.3c-1.962,0-2.574,1.081-2.574,2.19v2.632h4.379l-.7,4.054H16.73v8.613h8.739a2.9,2.9,0,0,0,3.056-2.714V4.964A2.9,2.9,0,0,0,25.469,2.25Z",
    transform: "translate(0 -2.25)",
    fill: "#130f53"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.3f8256a5.svg";
export { ForwardRef as ReactComponent };